import ProgressBar from "react-bootstrap/ProgressBar";
import Spinner from "react-bootstrap/Spinner";
import Moment from "react-moment";
import * as CommonUtilities from "../../../common/utils/CommonUtils.js";

export default function Order(props) {
    
    const warningText = "#BE6717";
    const darkText = "#212529";

    let isWebOrder;
    let isCateringMenu = CommonUtilities.StaticFields.PickupMenuType === 'webordering';
    if (isCateringMenu) {
        isWebOrder = true;
    } else {
        isWebOrder = props.urlConfig.Type === '' || props.urlConfig.Type === null || props.urlConfig.Type === 'null' || props.urlConfig.Type === 'web' ? true : false;
    }
    const isDelivery = props.urlConfig.MenuType === 'delivery';
    
    let deliveryFromText = isDelivery ? 
        <div className="col-12 text-center mb-3 fw-medium">
            Delivering from
        </div>
        : <></>

    let getDirectionsButtonSection = isDelivery ?
        <></> 
        : <div className="col-12 row p-0 m-0 justify-content-center">
            <div className="col-sm-6 d-grid gap-2 px-0">
                <a className="btn btn-light border rounded-pill mt-3" href={`https://www.google.com/maps/dir//${props.order.gpsLatitude},${props.order.gpsLongitude}`} target="_blank">
                    Get Directions
                </a>
            </div>
        </div>

    let progressBarAmount = 0;
    let progressText = "Waiting for the store to accept your order.";
    let progressTextColor = darkText;
    let inProgress = true;

    switch(props.order.orderStatusID){
        case 0: 
            // POS Rejected
            progressBarAmount = 0;
            progressText = "Your order has not been accepted by the store. Any payment made has been refunded.";
            progressTextColor = warningText;
            inProgress = false;
            break;
        case 1:
            // POS Accepted
            progressBarAmount = 25;
            progressText = "Your order has been accepted!";
            inProgress = false;
            break;
        case 2:
            // Preparing
            progressBarAmount = 50;
            progressText = "Your order is being prepared.";
            inProgress = false;
            break;
        case 3:
            // Ready
            progressBarAmount = 75;
            progressText = "Your order is ready for pick up!";
            inProgress = false;
            break;
        case 4:
            // Collected
            progressBarAmount = 100;
            progressText = "Your order has been collected!";
            inProgress = false;
            break;
        case 5:
            // Refund
            progressBarAmount = 0;
            progressText = "Your order has not been accepted by the store. Any payment made has been refunded.";
            progressTextColor = warningText;
            inProgress = false;
            break;
        case 6:
            // Send To POS
            progressBarAmount = 0;
            progressText = "Waiting for the store to accept your order.";
            inProgress = true;
            break;
        default:
            // Fallback
            progressBarAmount = 0;
            progressText = "Waiting for the store to accept your order.";
            inProgress = true;
    }

    let originalBusinessPhone = props.order.businessPhone;
    let amendedBusinessPhone = "";
    if (CommonUtilities.RegexPatterns.regexMobile.test(originalBusinessPhone)) {
        // Mobile - 10 Digits
        amendedBusinessPhone = `${originalBusinessPhone.slice(0, 4)} ${originalBusinessPhone.slice(4, 7)} ${originalBusinessPhone.slice(7, 10)}`;
    } else if (CommonUtilities.RegexPatterns.regexLandline10Char.test(originalBusinessPhone)) {
        // Landline - 10 Digits
        amendedBusinessPhone = `${originalBusinessPhone.slice(0, 2)} ${originalBusinessPhone.slice(2, 6)} ${originalBusinessPhone.slice(6, 10)}`;
    } else if (CommonUtilities.RegexPatterns.regexLandline8Char.test(originalBusinessPhone)) {
        // Landline - 8 Digits
        amendedBusinessPhone = `${originalBusinessPhone.slice(0, 4)} ${originalBusinessPhone.slice(4, 8)}`;
    } else {
        // Fallback
        amendedBusinessPhone = originalBusinessPhone;
    }

    return (
        <div className="border border-light-subtle border-2 rounded-3 my-5 p-3 p-sm-4">
            <div className="row gap-2">
                <div className="col-12 text-center">
                    <div className="h5 m-0">{`Order #${props.order.cartSummaryRecId}`}</div>
                    {isWebOrder &&
                        <div className="text-secondary">Placed at <Moment parse="YYYY-MM-DDTHH:mm:ss" format="h:mma">{props.order.paymentDate}</Moment> on <Moment parse="YYYY-MM-DDTHH:mm:ss" format="DD/MM/YYYY">{props.order.paymentDate}</Moment></div>
                    }
                </div>
                <div className="col-12 text-center mt-3">Your order confirmation has been emailed to you</div>
                {isWebOrder &&
                    <>
                        {!isCateringMenu && 
                            <div className="col-sm-8 offset-sm-2 col-md-6 offset-md-3 mt-3">
                                <div className="text-center mb-3">
                                    {inProgress && <Spinner animation="border" role="status" variant="secondary" size="sm"></Spinner>}
                                </div>
                                <ProgressBar variant="success" now={progressBarAmount} />
                                <div className={`text-center mt-2 fw-medium`} style={{color: progressTextColor}}>{progressText}</div>
                            </div>
                        }

                        <div className="col-12 row p-0 m-0 px-2 justify-content-center mt-4">
                            <div className="col-sm-8 col-md-6 bg-light rounded-3 row m-0 p-2">
                                {deliveryFromText}
                                <div className="col-sm-6">
                                    <span className="fw-medium">{props.order.locationName}</span><br />
                                    {props.order.businessAddressLine1 && <><span>{props.order.businessAddressLine1}</span><br /></>}
                                    {props.order.businessAddressLine2 && <><span>{props.order.businessAddressLine2}</span><br /></>}
                                    <span>{props.order?.businessSuburb && props.order.businessSuburb} {props.order.businessStateName} {props.order.businessPostCode}</span>
                                </div>
                                <div className="col-sm-6 text-sm-end text-start mt-sm-0 mt-3">
                                    {props.order.businessPhone && 
                                    <>
                                        <span>Contact Store</span><br />
                                        <a href={`tel:${props.order.businessPhone}`}>{amendedBusinessPhone}</a>
                                    </>}
                                </div>
                            </div>
                        </div>
                        {getDirectionsButtonSection}
                    </>
                }
            </div>
        </div>
    )
}